import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import axios from "axios";
import {ConversationDto} from "../../dto/ConversationDto";

interface ConversationsState {
    conversationsByAgentId: Record<string, ConversationDto[]>;
    conversationByConversationId: Record<string, ConversationDto>;
    selectedConversationId: string | null;
    loadingAll: boolean;
    loadingConversation: boolean;
    deleting: boolean;
    error: string | null;
}

const initialState: ConversationsState = {
    conversationsByAgentId: {},
    conversationByConversationId: {},
    selectedConversationId: null,
    loadingAll: false,
    loadingConversation: false,
    deleting: false,
    error: null,
};

export const fetchConversations = createAsyncThunk(
    'conversations/fetchConversations',
    async ({agentId, token}: {agentId: string, token: string}) => {
        const response = await axios.get(`/api/agents/${agentId}/conversations`, {headers: {Authorization: `Bearer ${token}`}});
        return { agentId, conversations: response.data };
    }
);

export const fetchConversationById = createAsyncThunk(
    'conversations/fetchConversationById',
    async ({agentId, conversationId, token}: {agentId: string, conversationId: string, token: string}) => {
        const response = await axios.get(`/api/agents/${agentId}/conversations/${conversationId}`, {headers: {Authorization: `Bearer ${token}`}});
        return response.data;
    }
);

const conversationsSlice = createSlice({
    name: 'conversations',
    initialState,
    reducers: {
        setSelectedConversationId(state, action: PayloadAction<string | null>) {
            state.selectedConversationId = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchConversations.pending, (state) => {
                state.loadingAll = true;
            })
            .addCase(fetchConversations.fulfilled, (state, action) => {
                state.loadingAll = false;
                state.conversationsByAgentId[action.payload.agentId] = action.payload.conversations;
                state.selectedConversationId = null;
            })
            .addCase(fetchConversations.rejected, (state) => {
                state.loadingAll = false;
            })
            .addCase(fetchConversationById.pending, (state) => {
                state.loadingConversation = true;
            })
            .addCase(fetchConversationById.fulfilled, (state, action) => {
                state.loadingConversation = false;
                const fullConversation = action.payload;
                state.conversationByConversationId[fullConversation.conversationId] = fullConversation;
            })
            .addCase(fetchConversationById.rejected, (state) => {
                state.loadingConversation = false;
            });
    },
});

export const { setSelectedConversationId } = conversationsSlice.actions;

export default conversationsSlice.reducer;